import { render } from "./LessonsContent.vue?vue&type=template&id=4d3e7a84&scoped=true"
import script from "./LessonsContent.vue?vue&type=script&lang=js"
export * from "./LessonsContent.vue?vue&type=script&lang=js"

import "./LessonsContent.vue?vue&type=style&index=0&id=4d3e7a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3e7a84"]])

export default __exports__